import React from 'react';
import PropTypes from 'prop-types';

import { Form } from 'react-form';
import Popup from '../../Popup';
import { Textarea } from '../../Form';
import { createReactFormValidator, maxWordLength } from '../../../utils/validation';

import styles from './PaidHitAvailabilityPopup.scss';

const PaidHitAvailabilityPopup = ({
    onCloseClick,
    onSendClick,
    title,
    subTitle,
    paidHitAvailability,
    isSendingPaidHitRequest,
    'data-testid': dataTestId,
}) => {
    const toShowPaidHitAvailability = paidHitAvailability ? paidHitAvailability.filter(a => a.isAvailable) : [];
    const minHeight = window ? (window.innerHeight > 650 ? 650 : window.innerHeight) : '100%';
    const PaidHitAvailabilityContent = (props) => (
        <div className={`${styles.value} mb16`}>
            <span className="text-capitalize">{props.day}</span>
            <div className={`${styles.bold} text-line-break mt8`}>
                {props.availability}
            </div>
        </div>
    );
    return (
        <Popup
            className={`popup-md`}
            onCloseClick={onCloseClick}
            popUpContentWrapperClassName={`overflow-unset`}
            config={{
                noPadding: false,
                fullScreen: false,
                topGradient: true,
                scrollable: true,
                style: {
                    height: '650',
                    maxHeight: '75%',
                    minHeight,
                },
            }}
        >
            <div className="popup-section pt16" data-testid={dataTestId}>
                <Form
                    onSubmit={values => onSendClick({ values })}
                >
                    {({ submitForm }) => {
                        return (
                            <form onSubmit={submitForm} id="reportConversationForm" data-testid={dataTestId ? `${dataTestId}.form` : undefined}>
                                <div className="row">
                                    <div className="col-12">
                                        <h5 className={`text-uppercase`} data-testid={dataTestId ? `${dataTestId}.title` : undefined}>{title}</h5>
                                    </div>
                                    <div className={`${styles.paidhit} col-12 mt16`}>
                                        {toShowPaidHitAvailability.length > 0 && (
                                            <>
                                                <label data-testid={dataTestId ? `${dataTestId}.availability-label` : undefined}>Paid Hit Availability</label>
                                                <div className={`col-12 mt16`}>
                                                    {toShowPaidHitAvailability.map((data, i) => {
                                                        return (
                                                            <PaidHitAvailabilityContent
                                                                key={`availability-item-${i}`}
                                                                {...data}
                                                            />
                                                        );
                                                    })}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                    <div className="col-12 mt16">
                                        <Textarea
                                            label="Message"
                                            description={subTitle}
                                            id="message"
                                            field="message"
                                            rows="5"
                                            validate={createReactFormValidator([maxWordLength(100)])}
                                            placeholder="Type message here.."
                                            data-testid="paidhitavailabilitypopup.message-textarea"
                                        />
                                    </div>
                                    <div className="row w-100 text-center">
                                        <div className="col-12 col-md-6">
                                            <button
                                                onClick={onCloseClick}
                                                type="button"
                                                className="btn btn-default btn-xl text-uppercase btn-block"
                                                data-testid={dataTestId ? `${dataTestId}.cancel-btn` : undefined}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <button
                                                type="submit"
                                                className="btn btn-primary btn-xl text-uppercase btn-block"
                                                disabled={isSendingPaidHitRequest}
                                                data-testid={dataTestId ? `${dataTestId}.send-btn` : undefined}
                                            >
                                                send
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        );
                    }}
                </Form>
            </div>
        </Popup>
    );
};

export default PaidHitAvailabilityPopup;

PaidHitAvailabilityPopup.propTypes = {
    title: PropTypes.string,
};

PaidHitAvailabilityPopup.defaultProps = {
    title: '',
};
